import {newsEntries} from '@/config/newsEntries';

export const seenIds = (state) => state.seenIds;
export const loaded = (state) => state.loaded;

// newsEntries je uz nejnovejsi-prvni (stejne jako zalozka Novinky) - popup
// zamerne razeni nemeni (update 2026-08-27, viz
// docs/superpowers/specs/2026-08-27-changelog-seen-tracking-design.md) - od
// te doby, co se vsechny zobrazene polozky oznaci jako videne hned pri
// otevreni popupu (ne postupne podle prolistovani), uz nedava smysl vnucovat
// chronologicke poradi "dojet co jsi zmeskal".
export const unseenEntries = (state) => {
    return newsEntries.filter((entry) => !state.seenIds.includes(entry.key));
};
